import axios from 'axios';

// withCredentials is required: identity comes from the shared cross-subdomain
// skit_token cookie Portal sets at login, not a locally-stored token — the
// browser only attaches it automatically if the request opts in.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res.data,
  async (err) => {
    // When responseType:'blob' is used, error responses also arrive as Blobs.
    // We must read the blob as text to extract the real JSON message.
    let message = err.message || 'Network error';
    if (err.response) {
      const data = err.response.data;
      if (data instanceof Blob && data.type?.includes('json')) {
        try {
          const text = await data.text();
          const json = JSON.parse(text);
          message = json.message || json.error || message;
        } catch { /* keep default message */ }
      } else {
        message = data?.message || data?.error || message;
      }

      // No session (or it expired) — Portal is the only place to log in.
      if (err.response.status === 401) {
        const portalUrl = process.env.REACT_APP_PORTAL_URL;
        window.location.href = portalUrl ? `${portalUrl}/login` : '/login';
      }
    }
    return Promise.reject(new Error(message));
  }
);

export default api;
